var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    { staticClass: "px-3 d-flex flex-column fill-height" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "header-sticky flex-grow-1" },
        [
          _c(
            "v-card",
            {
              staticClass: "w-100 d-flex flex-column flex-grow-1",
              attrs: {
                color: _vm.cardColor,
                "min-width": "640",
                width: "100%",
                elevation: "0",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "start", "no-gutters": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { large: "" } },
                        [_vm._v("mdi-chart-timeline")]
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("workTimeReport")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "d-flex flex-column flex-grow-1" },
                [
                  _c(
                    "v-row",
                    { staticClass: "my-3", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: _vm.getButtonSelectionState("daily"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setButtonSelection("daily")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("dailyReport")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: _vm.getButtonSelectionState("weekly"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setButtonSelection("weekly")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("weeklyReport")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: _vm.getButtonSelectionState("monthly"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setButtonSelection("monthly")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("monthlyReport")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: _vm.getButtonSelectionState("yearly"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setButtonSelection("yearly")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("yearlyReport")) + " ")]
                      ),
                      _c("v-spacer"),
                      _vm.displayData.length > 0
                        ? _c(
                            "v-row",
                            {
                              staticClass: "pa-0 ma-0",
                              attrs: {
                                align: "center",
                                justify: "end",
                                "no-gutters": "",
                              },
                            },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", color: "primary" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  staticClass: "pr-4",
                                                  on: {
                                                    click: _vm.resetFilterCache,
                                                  },
                                                },
                                                on
                                              ),
                                              [_vm._v(" mdi-arrow-u-left-top ")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1660696825
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("resetFilter"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  attrs: {
                                    "prepend-icon": "mdi-filter-outline",
                                    color: "white--text",
                                  },
                                  on: { click: _vm.handleSelectionClick },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("filterColumns")) + " "
                                  ),
                                ]
                              ),
                              _c("v-divider", {
                                staticClass: "mx-3",
                                attrs: { vertical: "" },
                              }),
                              _c(
                                "div",
                                { staticClass: "d-flex page-size-wrapper" },
                                [
                                  _c("v-select", {
                                    staticClass: "page-size-select",
                                    attrs: {
                                      label: _vm.$t("pageSize"),
                                      items: _vm.pageSizes,
                                      outlined: "",
                                      "hide-details": "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.pageSize,
                                      callback: function ($$v) {
                                        _vm.pageSize = $$v
                                      },
                                      expression: "pageSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("v-divider", {
                                staticClass: "mx-3",
                                attrs: { vertical: "" },
                              }),
                              _c(
                                "v-tooltip",
                                {
                                  staticClass: "white-text",
                                  attrs: { bottom: "", color: "primary" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: _vm.handleCSVExport,
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { large: "" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-file-export-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1723375481
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("exportBtn"))),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0 align-center" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-1" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.teams,
                              "item-text": "Team",
                              color: "primary",
                              chips: "",
                              elevated: "",
                              "prepend-icon": "mdi-account-group",
                              label: _vm.$t("teams"),
                              multiple: "",
                              "hide-details": "",
                              dense: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    data.index < 3
                                      ? _c(
                                          "v-chip",
                                          _vm._b(
                                            {
                                              attrs: {
                                                "input-value": data.selected,
                                                close: "",
                                              },
                                              on: {
                                                click: data.select,
                                                "click:close": function (
                                                  $event
                                                ) {
                                                  return _vm.removeSelectedTeam(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            "v-chip",
                                            data.attrs,
                                            false
                                          ),
                                          [
                                            _vm._v(
                                              " " + _vm._s(data.item) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    data.index ===
                                      _vm.selectedTeams.length - 1 &&
                                    _vm.selectedTeams.length > 3
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                ` (+${
                                                  _vm.selectedTeams.length - 3
                                                })`
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedTeams,
                              callback: function ($$v) {
                                _vm.selectedTeams = $$v
                              },
                              expression: "selectedTeams",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _vm.currentView !== "perDepartment"
                            ? _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.filteredEmployees,
                                  "item-text": "name",
                                  color: "primary",
                                  chips: "",
                                  elevated: "",
                                  label: _vm.$t("employees"),
                                  multiple: "",
                                  "prepend-icon": "mdi-account",
                                  "hide-details": "",
                                  dense: "",
                                  "return-object": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prepend-item",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-list-item",
                                            {
                                              attrs: {
                                                ripple: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              on: {
                                                mousedown: function ($event) {
                                                  $event.preventDefault()
                                                },
                                                click: _vm.handleSelectAll,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.selectedEmployees
                                                            .length > 0
                                                            ? "red darken-4"
                                                            : "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedEmployees
                                                              .length > 0
                                                              ? "mdi-checkbox-marked"
                                                              : "mdi-checkbox-blank-outline"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("selectAll")
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-divider", {
                                            staticClass: "mt-2",
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        data.index < 1
                                                          ? _c(
                                                              "v-chip",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      "input-value":
                                                                        data.selected,
                                                                      close: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        data.select,
                                                                      "click:close":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeSelectedEmployee(
                                                                            data.item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  "v-chip",
                                                                  data.attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.item
                                                                        .name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedEmployees
                                                      .map((e) => e.name)
                                                      .join(", \n")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          data.index ===
                                            _vm.selectedEmployees.length - 1 &&
                                          _vm.selectedEmployees.length > 1
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      ` (+${
                                                        _vm.selectedEmployees
                                                          .length - 1
                                                      })`
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(_vm._s(data.item.name)),
                                              ]),
                                              _c("v-list-item-subtitle", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.setTeamsForAutocomplete(
                                                        data.item.teams
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3725792816
                                ),
                                model: {
                                  value: _vm.selectedEmployees,
                                  callback: function ($$v) {
                                    _vm.selectedEmployees = $$v
                                  },
                                  expression: "selectedEmployees",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-2",
                          staticStyle: { display: "inline-flex" },
                        },
                        [
                          _c("v-icon", [
                            _vm._v("mdi-calendar-multiselect-outline"),
                          ]),
                          _c("DatePicker", {
                            attrs: {
                              dense: "",
                              mydate1: _vm.date.from,
                              label: _vm.$t("dateFrom"),
                            },
                            model: {
                              value: _vm.date.from,
                              callback: function ($$v) {
                                _vm.$set(_vm.date, "from", $$v)
                              },
                              expression: "date.from",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-2",
                          staticStyle: { display: "inline-flex" },
                        },
                        [
                          _c("v-icon", [
                            _vm._v("mdi-calendar-multiselect-outline"),
                          ]),
                          _c("DatePicker", {
                            attrs: {
                              dense: "",
                              mydate1: _vm.date.until,
                              label: _vm.$t("dateUntil"),
                            },
                            model: {
                              value: _vm.date.until,
                              callback: function ($$v) {
                                _vm.$set(_vm.date, "until", $$v)
                              },
                              expression: "date.until",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.loaderOverlay
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-3 mr-1",
                              attrs: { color: "primary" },
                              on: { click: _vm.fetch },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mx-3",
                              attrs: { color: "primary", icon: "" },
                            },
                            [
                              _c("v-icon", { staticClass: "rotate" }, [
                                _vm._v("mdi-refresh"),
                              ]),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0 flex-grow-1" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0 d-flex flex-column" },
                        [
                          _vm.displayData.length > 0
                            ? _c(
                                "v-sheet",
                                {
                                  staticClass: "report-scroll",
                                  style: {
                                    height: _vm.listHeight + "px",
                                    maxHeight: _vm.listHeight + "px",
                                  },
                                },
                                [
                                  _c("DynamicList", {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      searchTerm: _vm.searchTerm,
                                      pageSize: _vm.pageSize,
                                      data: _vm.displayData,
                                      styles: _vm.styles,
                                      headers: _vm.headers,
                                      headerTypes: _vm.headerTypes,
                                      columnTypes: _vm.columnTypes,
                                      columnSelection: _vm.columnSelection,
                                    },
                                  }),
                                ],
                                1
                              )
                            : !_vm.loaderOverlay
                            ? _c(
                                "v-card",
                                {
                                  staticClass:
                                    "mx-0 mt-2 py-5 flex-grow-1 d-flex align-center justify-center",
                                },
                                [_c("NoData")],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "wrapper mt-5",
          staticStyle: { position: "fixed" },
          style: { top: _vm.position.top, left: _vm.position.left },
          attrs: { cols: "2" },
        },
        [
          _vm.selectionIsOpen
            ? _c(
                "v-card",
                {
                  staticClass: "mr-10 pa-5",
                  attrs: {
                    color: _vm.$vuetify.theme.dark
                      ? "#1E1E1E"
                      : "grey lighten-2",
                    width: "unset",
                  },
                },
                [
                  _c("ColumnControl", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.handleOutsideClick,
                        expression: "handleOutsideClick",
                      },
                    ],
                    attrs: {
                      id: "column-control",
                      headers: _vm.headers,
                      columnSelection: _vm.columnSelection,
                    },
                    on: { update: _vm.updateSelectedColumns },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("LoadingInfo", {
        attrs: {
          state: _vm.loadingInfo.state,
          message: _vm.loadingInfo.message,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }